import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import CloseButton from 'components/CustomButtons/CloseButton';
import { previousModalPage } from 'actions/modalPage';
import { getSetting } from 'reducers/configs/settings';

import { SalesList } from './index';

type Props = {
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
  customerID: number | string;
};

const PreviousSales: FC<Props> = ({ resolve, reject, customerID }) => {
  const dispatch = useDispatch();
  const close = () => {
    dispatch(previousModalPage());
    resolve();
  };
  const useOldSalesHistoryService = useSelector(
    getSetting('use_old_sales_history_service', '0'),
  );
  const title = Number(useOldSalesHistoryService)
    ? 'Previously purchased products'
    : 'View historical sales documents';
  return (
    <>
      <Modal.Header>
        <h3 className="font-weight-bold">{title}</h3>
        <span style={{ flexGrow: 1 }} />
        <CloseButton action={close} />
      </Modal.Header>
      <Modal.Body>
        <SalesList
          useOldSalesHistoryService={Boolean(Number(useOldSalesHistoryService))}
          customerID={customerID}
        />
      </Modal.Body>
    </>
  );
};

export default PreviousSales;
